import { AppTable, AppModal } from '@/shared/ui'
import { FunctionComponent, useEffect, useState } from 'react'

export type GroupStoresProps = {
  isVisible: boolean
  userGroup: string
  storesData: any
  translate: (arg0: string) => string
  getCities: () => any
  getStores: (arg0: any) => any
  toClose: () => void
  tableChange: () => any
  searchBar: any
  cities: any
  pagination: any
}

export const GroupStoresModal: FunctionComponent<GroupStoresProps> = ({
  isVisible = false,
  userGroup = '',
  translate = (arg0: string) => '',
  toClose = () => {},
  storesData = null,
  tableChange = () => {},
  searchBar = null,
  cities = null,
  pagination = null
}: GroupStoresProps): JSX.Element => {
  const PAGE_SIZE = 6

  return (
    <AppModal
      title={'Tiendas asignadas a tu grupo - ' + userGroup}
      open={isVisible}
      onCancel={toClose}
      centered={true}
      footer={null}
      keyboard={true}
      maskClosable={true}
      width={1200}
      closable={true}
    >
      {searchBar}
      <AppTable
        locale={{ filterReset: translate('resources.tab.STORES.table.filterReset') }}
        onChange={tableChange}
        columns={[
          {
            title: translate('resources.tab.STORES.table.photo'),
            dataIndex: 'photo',
            key: 'photo'
          },
          {
            title: translate('resources.tab.STORES.table.name'),
            dataIndex: 'name',
            key: 'name'
          },
          {
            title: translate('resources.tab.STORES.table.city'),
            dataIndex: 'city',
            key: 'city',
            filters: cities,
            filterMultiple: false
          },
          {
            title: translate('resources.tab.STORES.table.fleets'),
            dataIndex: 'fleets',
            key: 'fleets'
          }
        ]}
        dataSource={storesData}
        pagination={pagination}
      />
    </AppModal>
  )
}
export {}
